/**
 * Helpers de tabela (PO1-2724) para telas com ordenação/paginação client-side,
 * no mesmo contrato de `SortHeader` e `TablePagination`.
 */

const collator =
  typeof Intl !== "undefined" && Intl.Collator
    ? new Intl.Collator("pt-BR", { numeric: true, sensitivity: "base" })
    : null;

/** Mesmo campo inverte a direção; campo novo começa em "asc" (= handleOrdenar da Auditoria de Faturas). */
export function toggleSort(sort, field) {
  if (sort && sort.field === field) {
    return { field, dir: sort.dir === "asc" ? "desc" : "asc" };
  }
  return { field, dir: "asc" };
}

function isEmpty(value) {
  return value === null || value === undefined || value === "";
}

function compareValues(a, b) {
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
  if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
  const sa = String(a);
  const sb = String(b);
  if (collator) return collator.compare(sa, sb);
  return sa < sb ? -1 : sa > sb ? 1 : 0;
}

/**
 * Ordena sem mutar: nulls/vazios por último em qualquer direção; empate mantém
 * a ordem original. `getValue(row, field)` é opcional (default: row[field]).
 */
export function sortRows(rows, sort, getValue) {
  const list = Array.isArray(rows) ? rows : [];
  if (!sort || !sort.field) return list;
  const accessor = typeof getValue === "function" ? getValue : (row, field) => (row ? row[field] : undefined);
  const direction = sort.dir === "desc" ? -1 : 1;

  return list
    .map((row, index) => ({ row, index }))
    .sort((a, b) => {
      const va = accessor(a.row, sort.field);
      const vb = accessor(b.row, sort.field);
      const ea = isEmpty(va);
      const eb = isEmpty(vb);
      if (ea && eb) return a.index - b.index;
      if (ea) return 1;
      if (eb) return -1;
      const cmp = compareValues(va, vb);
      if (cmp === 0) return a.index - b.index;
      return cmp * direction;
    })
    .map((entry) => entry.row);
}

/** Fatia a lista para a página pedida; devolve também a página clampada e o total de páginas. */
export function paginate(rows, page, pageSize) {
  const list = Array.isArray(rows) ? rows : [];
  const size = Math.max(1, Number(pageSize) || 10);
  const totalPages = Math.max(1, Math.ceil(list.length / size));
  const current = Math.min(Math.max(1, Number(page) || 1), totalPages);
  const start = (current - 1) * size;
  return {
    items: list.slice(start, start + size),
    page: current,
    totalPages,
    total: list.length,
  };
}
